<section class="d-flex justify-content-center align-items-center ">
  <div class=" image-wrapper">
    <!-- <img src="assets/icons/circle.png" class="img-fluid circle" id="circle" alt="zumer circle"> -->
    <div class="z_images">
      <img src="assets/icons/top_z_red.png" class="img-fluid z-image z-1" id="zTop" alt="zumer top logo">
      <img src="assets/icons/bottom_z_red.png" class="img-fluid z-image z-2" id="zBottom" alt="zumer bottom logo">
    </div>
    
    <div class="title">
      <h2 id="comp_name">ZUMERA</h2>
      <p id="comp_slogan">Inspiring A Better Future.</p>
    </div>
  </div>
</section>